export const ORDER_ACTION_NONE: string = 'ORDER_ACTION_NONE';
export const ORDER_ACTION_RETURN: string = 'ORDER_ACTION_RETURN';
export const ORDER_ACTION_EXCHANGE: string = 'ORDER_ACTION_EXCHANGE';

export const ORDER_PAGE_STEPS = {
  DEFAULT_STEP: 'default_page',
  EXCHANGE_STEP: 'exchange_selection_step',
  RETURN_STEP: 'return_selection_step'
};
